import { ErrorBox } from "@gearbox-protocol/deploy-tools-ui";
import { getChain } from "@gearbox-protocol/sdk/onchain";
import type { FC } from "react";
import { useMemo } from "react";
import { createPublicClient, http } from "viem";

import { useUnpausedForkStatus } from "../context";
import BalancesList from "./BalancesList";
import CollapsiblePanel from "./CollapsiblePanel";
import { useFaucet } from "./FaucetProvider";
import { useTokenBalances } from "./useTokenBalances";

const FaucetAssetsCard: FC = () => {
  const { address } = useFaucet();
  const { rpcUrl, originChainId } = useUnpausedForkStatus();

  const publicClient = useMemo(
    () =>
      createPublicClient({
        transport: http(rpcUrl),
        chain: getChain(originChainId),
      }),
    [rpcUrl, originChainId],
  );

  const faucetBalances = useTokenBalances(publicClient, address);

  return (
    <div className="flex flex-col gap-3 rounded-lg border border-border p-4">
      <CollapsiblePanel
        id="faucet_v2_assets"
        title={<h3>Faucet assets</h3>}
        initiallyCollapsed
      >
        <div className="pt-3">
          {!!faucetBalances.error && <ErrorBox error={faucetBalances.error} />}

          <BalancesList
            tokens={faucetBalances.value}
            emptyMessage="Faucet doesn't have any tokens with non-zero balance"
          />
        </div>
      </CollapsiblePanel>
    </div>
  );
};

export default FaucetAssetsCard;
